import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];
const VIEW = { once: true, amount: 0.15 };

const lineVariants = {
  hidden: { y: "108%" },
  show: ({ i, d }) => ({ y: "0%", transition: { duration: 1.1, ease: EASE, delay: d + i * 0.12 } }),
};

export const Lines = ({ lines, className = "", lineClass = "", as = "h2", onMount = false, delay = 0, testid }) => {
  const Tag = motion[as];
  const trigger = onMount ? { animate: "show" } : { whileInView: "show", viewport: VIEW };
  return (
    <Tag className={className} initial="hidden" {...trigger} data-testid={testid}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span className={`block ${lineClass}`} variants={lineVariants} custom={{ i, d: delay }}>{l}</motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const FadeUp = ({ children, className = "", delay = 0, y = 28, as = "div", ...rest }) => {
  const Tag = motion[as];
  return (
    <Tag className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }} viewport={VIEW}
      transition={{ duration: 1, ease: EASE, delay }} {...rest}>
      {children}
    </Tag>
  );
};

export const ImgReveal = ({ src, alt, className = "", imgClass = "", delay = 0, eager = false }) => (
  <motion.div className={`bg-[#F0F0F0] ${className}`} initial="hidden" whileInView="show" viewport={VIEW}>
    <motion.div className="w-full h-full overflow-hidden"
      variants={{ hidden: { clipPath: "inset(0 0 18% 0)", opacity: 0.4 }, show: { clipPath: "inset(0 0 0% 0)", opacity: 1, transition: { duration: 1.4, ease: EASE, delay } } }}>
      {src && <motion.img src={src} alt={alt} loading={eager ? "eager" : "lazy"} className={`w-full h-full object-cover ${imgClass}`}
        variants={{ hidden: { scale: 1.12 }, show: { scale: 1, transition: { duration: 1.8, ease: EASE, delay } } }} />}
    </motion.div>
  </motion.div>
);

export const DrawLine = ({ className = "", dark = false, delay = 0 }) => (
  <motion.span aria-hidden="true" className={`block h-px origin-left ${dark ? "bg-[#FFFFFF]/30" : "bg-[#1A1A1A]/20"} ${className}`}
    initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={VIEW} transition={{ duration: 1.4, ease: EASE, delay }} />
);
